class SideNav {
  
  onReadyEvents() {
    var jobCount = $("#sidenav-modal .in").length;
    $(".list-count").text(jobCount + " items");

    $("#expanded-navMobileSearch").keyup(function () {
      //$(this).addClass('hidden');
      var searchTerm = $("#expanded-navMobileSearch").val();
      var searchSplit = searchTerm.replace(/ /g, "'):containsi('");
      //extends :contains to be case insensitive
      $.extend($.expr[":"], {
        containsi: function (elem, i, match, array) {
          return (
            (elem.textContent || elem.innerText || "")
              .toLowerCase()
              .indexOf((match[3] || "").toLowerCase()) >= 0
          );
        },
      });

      /** Search page links **/
      $("#expanded-view .nav-link")
        .not(":containsi('" + searchSplit + "')")
        .each(function (e) {
          $(this).addClass("hiding out").removeClass("in");
          setTimeout(function () {
            $(".out").addClass("hidden");
          }, 300);
        });

      $("#expanded-view .nav-link:containsi('" + searchSplit + "')").each(
        function (e) {
          $(this).removeClass("hidden out").addClass("in");
          setTimeout(function () {
            $(".in").removeClass("hiding");
          }, 1);
        }
      );

      /** Search rendered links **/
      $("#expanded-view a")
        .not(":containsi('" + searchSplit + "')")
        .each(function (e) {
          $(this).addClass("hiding out").removeClass("in");
          setTimeout(function () {
            $(".out").addClass("hidden");
          }, 300);
        });

      $("#expanded-view a:containsi('" + searchSplit + "')").each(function (e) {
        $(this).removeClass("hidden out").addClass("in");
        setTimeout(function () {
          $(".in").removeClass("hiding");
        }, 1);
      });

      /** Search tools links **/
      $("#expanded-view .col-container")
        .not(":containsi('" + searchSplit + "')")
        .each(function (e) {
          $(this).addClass("hiding out").removeClass("in");
          setTimeout(function () {
            $(".out").addClass("hidden");
          }, 300);
        });

      $("#expanded-view .col-container:containsi('" + searchSplit + "')").each(
        function (e) {
          $(this).removeClass("hidden out").addClass("in");
          setTimeout(function () {
            $(".in").removeClass("hiding");
          }, 1);
        }
      );
      var jobCount = $("#expanded-view .in").length;
      $(".list-count").text(jobCount + " items");

      //shows empty state text when no jobs found
      if (jobCount == "0") {
        $("#expanded-view").addClass("empty");
      } else {
        $("#expanded-view").removeClass("empty");
      }
    });
  }
}

export default SideNav;
